<template>
  <div
    ref="container"
    class="df aic jcc"
    :style="{ width: isAdjust ? '100%' : '100%' }"
  >
    <!-- <div
      style="
        width: 100px;
        height: 100px;
        border-top: 5px solid #f00;
        border-right: 5px solid #f00;
        border-top-right-radius: 50%;
      "
    ></div> -->
    <!--  -->
    <div
      :style="{
        width: isAdjust ? '100%' : cellWidth * (cellConunt + 1) + 'px',
        margin: `0 0px 90px`,
      }"
    >
      <div
        v-for="item in Math.ceil(stepsData.length / cellConunt)"
        :key="item"
        class="df aic"
        :style="{
          marginLeft: item % 2 == 1 ? cellWidth + 'px' : '0',
          marginRight: item % 2 == 0 ? cellWidth + 'px' : '0',
          flexDirection: item % 2 == 0 ? 'row-reverse' : 'row',
        }"
      >
        <template v-for="dataItem in cellConunt">
          <!-- :class="{
              pointer: stepsData[(item - 1) * cellConunt + dataItem - 1].active,
            }" -->
          <div
            v-if="(item - 1) * cellConunt + dataItem <= stepsData.length"
            :key="dataItem"
            :style="{
              width: cellWidth + 'px',
              height: cellHeight + 'px',
              position: 'relative',
            }"
          >
            <div
              v-if="dataItem != cellConunt"
              :style="{
                zIndex: 10,
                position: 'absolute',
                left: 0,
                top: 0,
                width: cellWidth + 'px',
                height: cellHeight + 'px',
              }"
              class="df aic jcc"
            >
              <div
                style="
                  width: 36px;
                  height: 36px;
                  background-color: #fff;
                  border-radius: 50%;
                  position: relative;
                "
                @click="
                  toTrace(stepsData[(item - 1) * cellConunt + dataItem - 1])
                "
                :class="{
                  df: true,
                  aic: true,
                  jcc: true,
                  pointer:
                    stepsData[(item - 1) * cellConunt + dataItem - 1].active,
                }"
              >
                <div
                  :style="{
                    position: 'absolute',
                    lineHeight: '14px',
                    top: '-20px',
                    textAlign: 'center',
                    left: 0,
                    width: '100%',
                  }"
                >
                  <template
                    v-if="
                      !stepsData[(item - 1) * cellConunt + dataItem - 1].isCcp
                    "
                  >
                    <span
                      v-if="
                        stepsData[(item - 1) * cellConunt + dataItem - 1].active
                      "
                      style="color: #1d953f; font-size: 12px"
                      >已完成</span
                    >
                    <span v-else style="color: #c0c4cc; font-size: 12px"
                      >未完成</span
                    >
                  </template>
                  <span v-else style="color: #f56c6c; font-size: 12px"
                    >ccp点</span
                  >
                </div>
                <div
                  :style="{
                    fontSize: '16px',
                    position: 'absolute',
                    lineHeight: '18px',
                    top: 36 + 10 + 'px',
                    textAlign: 'center',
                    left: -(cellWidth - 36) / 2 + 'px',
                    width: cellWidth + 'px',
                    padding: '0 10px',
                    color: stepsData[(item - 1) * cellConunt + dataItem - 1]
                      .isCcp
                      ? '#f56c6c'
                      : stepsData[(item - 1) * cellConunt + dataItem - 1].active
                      ? '#1d953f'
                      : '#c0c4cc',
                  }"
                >
                  {{ stepsData[(item - 1) * cellConunt + dataItem - 1].name }}
                </div>
                <i
                  v-if="
                    stepsData[(item - 1) * cellConunt + dataItem - 1].active
                  "
                  class="el-icon-success"
                  style="font-size: 36px; color: #1d953f"
                ></i>
                <i
                  v-else
                  class="el-icon-error"
                  style="font-size: 36px; color: #c0c4cc"
                ></i>
              </div>
            </div>
            <div
              v-if="dataItem == cellConunt"
              :style="{
                zIndex: 10,
                position: 'absolute',
                left: 0,
                top: 0,
                width: cellWidth + 'px',
                height: cellHeight * 2 + 'px',
              }"
              class="df aic jcc"
            >
              <div
                style="
                  width: 36px;
                  height: 36px;
                  background-color: #fff;
                  border-radius: 50%;
                  position: relative;
                "
                @click="
                  toTrace(stepsData[(item - 1) * cellConunt + dataItem - 1])
                "
                :class="{
                  df: true,
                  aic: true,
                  jcc: true,
                  pointer:
                    stepsData[(item - 1) * cellConunt + dataItem - 1].active,
                }"
              >
                <div
                  v-if="item % 2 == 1"
                  :style="{
                    fontSize: '16px',
                    position: 'absolute',
                    lineHeight: '18px',
                    top: 0,
                    height: '36px',
                    textAlign: 'center',
                    left: 36 + 5 + 'px',
                    width: cellWidth - 26 + 'px',
                    color: stepsData[(item - 1) * cellConunt + dataItem - 1]
                      .isCcp
                      ? '#f56c6c'
                      : stepsData[(item - 1) * cellConunt + dataItem - 1].active
                      ? '#1d953f'
                      : '#c0c4cc',
                  }"
                  class="df aic jcc"
                >
                  <div style="width: 100%">
                    {{ stepsData[(item - 1) * cellConunt + dataItem - 1].name }}
                  </div>
                </div>
                <div
                  v-if="item % 2 == 1"
                  :style="{
                    position: 'absolute',
                    lineHeight: '14px',
                    top: '11px',
                    textAlign: 'center',
                    left: '-50px',
                    width: '100%',
                  }"
                >
                  <template
                    v-if="
                      !stepsData[(item - 1) * cellConunt + dataItem - 1].isCcp
                    "
                  >
                    <span
                      v-if="
                        stepsData[(item - 1) * cellConunt + dataItem - 1].active
                      "
                      style="color: #1d953f; font-size: 12px"
                      >已完成</span
                    >
                    <span v-else style="color: #c0c4cc; font-size: 12px"
                      >未完成</span
                    >
                  </template>
                  <span v-else style="color: #f56c6c; font-size: 12px"
                    >ccp点</span
                  >
                </div>
                <div
                  v-if="item % 2 == 0"
                  :style="{
                    position: 'absolute',
                    lineHeight: '14px',
                    top: '11px',
                    textAlign: 'center',
                    right: '-50px',
                    width: '100%',
                  }"
                >
                  <template
                    v-if="
                      !stepsData[(item - 1) * cellConunt + dataItem - 1].isCcp
                    "
                  >
                    <span
                      v-if="
                        stepsData[(item - 1) * cellConunt + dataItem - 1].active
                      "
                      style="color: #1d953f; font-size: 12px"
                      >已完成</span
                    >
                    <span v-else style="color: #c0c4cc; font-size: 12px"
                      >未完成</span
                    >
                  </template>
                  <span v-else style="color: #f56c6c; font-size: 12px"
                    >ccp点</span
                  >
                </div>

                <i
                  v-if="
                    stepsData[(item - 1) * cellConunt + dataItem - 1].active
                  "
                  class="el-icon-success"
                  style="font-size: 36px; color: #1d953f"
                ></i>
                <i
                  v-else
                  class="el-icon-error"
                  style="font-size: 36px; color: #c0c4cc"
                ></i>
              </div>
            </div>

            <div
              :style="{
                zIndex: 1,
                position: 'absolute',
                width: cellWidth + 'px',
                height:
                  dataItem == cellConunt
                    ? cellHeight + lineWidth + 'px'
                    : cellHeight + 'px',
                left: 0,
                top:
                  dataItem == cellConunt
                    ? cellHeight / 2 - lineWidth / 2 + 'px'
                    : 0,
                flexDirection: dataItem == cellConunt ? 'column' : 'row',
                padding:
                  dataItem == cellConunt
                    ? `${cellWidth / 2 + lineWidth / 2}px 0`
                    : '',
              }"
              class="df"
            >
              <div
                class="df aic jcc"
                :style="{
                  position: 'relative',
                  width: dataItem == cellConunt ? '100%' : cellWidth / 2 + 'px',
                  height:
                    dataItem == cellConunt
                      ? cellHeight / 2 + lineWidth + 'px'
                      : '100%',
                }"
              >
                <div
                  v-if="dataItem == cellConunt && item % 2 == 1"
                  :style="{
                    position: 'absolute',
                    left: 0,
                    top: -(cellWidth / 2 + lineWidth / 2) + 'px',
                    width: cellWidth / 2 + lineWidth / 2 + 'px',
                    height: cellWidth / 2 + lineWidth / 2 + 'px',
                    borderTop: `${lineWidth}px solid #C0C4CC`,
                    borderRight: `${lineWidth}px solid #C0C4CC`,
                    borderTopRightRadius: '50%',
                  }"
                ></div>
                <div
                  v-if="dataItem == cellConunt && item % 2 == 0"
                  :style="{
                    position: 'absolute',
                    right: 0,
                    top: -(cellWidth / 2 + lineWidth / 2) + 'px',
                    width: cellWidth / 2 + lineWidth / 2 + 'px',
                    height: cellWidth / 2 + lineWidth / 2 + 'px',
                    borderTop: `${lineWidth}px solid #C0C4CC`,
                    borderLeft: `${lineWidth}px solid #C0C4CC`,
                    borderTopLeftRadius: '50%',
                  }"
                ></div>
                <div
                  v-if="(item - 1) * cellConunt + dataItem - 1 !== 0"
                  :style="{
                    width: dataItem == cellConunt ? lineWidth + 'px' : '100%',
                    height: dataItem == cellConunt ? '100%' : lineWidth + 'px',
                    backgroundColor: '#C0C4CC',
                  }"
                ></div>
              </div>
              <div
                class="df aic jcc"
                :style="{
                  position: 'relative',
                  width: dataItem == cellConunt ? '100%' : cellWidth / 2 + 'px',
                  height:
                    dataItem == cellConunt ? cellHeight / 2 + 'px' : '100%',
                }"
              >
                <div
                  v-if="dataItem == cellConunt && item % 2 == 1"
                  :style="{
                    position: 'absolute',
                    left: 0,
                    bottom: -(cellWidth / 2 + lineWidth / 2) + 'px',
                    width: cellWidth / 2 + lineWidth / 2 + 'px',
                    height: cellWidth / 2 + lineWidth / 2 + 'px',
                    borderBottom: `${lineWidth}px solid #C0C4CC`,
                    borderRight: `${lineWidth}px solid #C0C4CC`,
                    borderBottomRightRadius: '50%',
                  }"
                ></div>
                <div
                  v-if="dataItem == cellConunt && item % 2 == 0"
                  :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: -(cellWidth / 2 + lineWidth / 2) + 'px',
                    width: cellWidth / 2 + lineWidth / 2 + 'px',
                    height: cellWidth / 2 + lineWidth / 2 + 'px',
                    borderBottom: `${lineWidth}px solid #C0C4CC`,
                    borderLeft: `${lineWidth}px solid #C0C4CC`,
                    borderBottomLeftRadius: '50%',
                  }"
                ></div>
                <div
                  :style="{
                    width: dataItem == cellConunt ? lineWidth + 'px' : '100%',
                    height: dataItem == cellConunt ? '100%' : lineWidth + 'px',
                    backgroundColor: '#C0C4CC',
                  }"
                ></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="t-dialog" id="fade-box" v-show="showInfo">
      <div class="p50 record-bg">
        <!-- <el-collapse v-model="activeName" accordion> -->
        <div v-for="(item, index) in traceList" :key="index" class="df pr">
          <div class="flex-8 tc col-fff f20 fw-b">
            <h1>{{ item.name }}</h1>
            <div
              v-if="item.ccpRemark"
              style="padding: 10px 20px; font-size: 14px"
            >
              关键限值:{{ item.ccpRemark }}
            </div>
          </div>
          <div class="flex-16 tl">
            <div v-if="item.type == 2" class="col-fff">
              <h1>{{ item.content }}</h1>
            </div>
            <div v-else-if="item.type == 1" class="">
              <el-image
                v-for="(src, srcIndex) in JSON.parse(item.content)"
                :key="srcIndex"
                style="width: 200px; height: 200px"
                :src="src.url"
                fit="cover"
                :preview-src-list="[src.url]"
                class="mr20 t-border mb10"
              >
                <template #error>
                  <div class="df aic jcc" style="background-color:#eee;height:100%">未抓取到摄像图片</div>
                </template>
              </el-image>
            </div>
            <div v-else-if="item.type == 6 || item.type == 17" class="">
              <el-image
                v-for="(src, srcIndex) in JSON.parse(item.content)"
                :key="srcIndex"
                style="width: 200px; height: 200px"
                :src="src.imgUrl"
                fit="cover"
                :preview-src-list="[src.imgUrl]"
                class="mr20 t-border mb10"
              >
                <template #error>
                  <div class="df aic jcc" style="background-color:#eee;height:100%">未抓取到摄像图片</div>
                </template>
              </el-image>
            </div>
            <div
              v-else-if="(item.type == 4 || item.type == 3) && showInfo"
              class="flex-16 tl"
            >
              <div
                v-for="(vidoe, vidoeIndex) in JSON.parse(item.content)"
                :key="vidoeIndex"
              >
                <video
                  Controls
                  :poster="vidoe + '?x-oss-process=video/snapshot,t_1,m_fast'"
                  class="video-js t-border mb10"
                  style="height: 260px; width: 100%; margin-bottom: 5px"
                >
                  <source :src="vidoe" type="video/mp4" />
                </video>
              </div>
            </div>
            <div v-else-if="item.type == 8 || item.type == 16">
              <div
                v-loading="item.loading"
                style="
                  width: 800px;
                  height: 320px;
                  border-radius: 10px;
                  margin-bottom: 10px;
                "
              >
                <CcpCharts
                  :name="item.name"
                  :historyList="item.historyData"
                  v-if="item.initFlag"
                  :hasMore="item.hasMore"
                  :unit="item.data.unit"
                  :index="item.id + '-' + index"
                  @pageChange="pageChange(item)"
                />
              </div>
            </div>
            <div v-else-if="item.type == 7">
              <div
                v-for="sensorItem in item.content"
                :key="sensorItem.id"
                v-loading="sensorItem.loading"
                style="
                  width: 800px;
                  height: 320px;
                  margin-bottom: 10px;
                  border-radius: 10px;
                "
              >
                <CcpCharts
                  :name="item.name"
                  :historyList="sensorItem.historyData"
                  :index="sensorItem.id + '-' + index"
                  :hasMore="sensorItem.hasMore"
                  :unit="sensorItem.data.unit"
                  v-if="sensorItem.initFlag"
                  @pageChange="pageChange(sensorItem)"
                />
              </div>
            </div>
            <div
              v-if="!item.isCollapse && isCcp"
              class="pointer"
              @click="openCollapse(item)"
              style="
                text-align: center;
                padding:10px
                width: 100%;
                background-color: #EDEDED;
                border-radius: 10px;
                color:#409EFF;
              "
            >
              纠偏记录<i
                class="el-icon-arrow-down"
                style="margin-left: 5px; color: #409eff"
              ></i>
            </div>
            <div
              v-if="item.isCollapse && isCcp"
              style="
                padding: 10px;
                width: 100%;
                background-color: #ededed;
                border-radius: 10px;
              "
            >
              <div>
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="item.form.text"
                >
                </el-input>
                <div class="df aic" style="flex-wrap: wrap">
                  <template v-if="item.form && item.form.imgs">
                    <div
                      v-for="(v, i) in item.form.imgs"
                      :key="'img' + i"
                      style="width: 100px; margin: 0 5px"
                    >
                      <div
                        style="
                          width: 80px;
                          height: 80px;
                          margin: 10px;
                          position: relative;
                        "
                        class="mask-container"
                      >
                        <div class="mask-box df aic jcc">
                          <i
                            class="el-icon-zoom-in pointer"
                            style="color: #fff"
                            @click="handlePreview(v.url)"
                          ></i>
                          <div style="width: 20px; height: 20px"></div>
                          <i
                            class="el-icon-delete pointer"
                            style="color: #fff"
                            @click="handleImgRemove(item, i)"
                          ></i>
                          <!-- el-icon-delete -->
                        </div>
                        <!-- <img
                          :src="v.url"
                          style="width: 100%; height: 100%; object-fit: cover"
                        /> -->
                        <el-image
                          :src="v.url"
                          :preview-src-list="[v.url]"
                          style="width: 100%; height: 100%; object-fit: cover"
                        >
                        </el-image>
                      </div>

                      <div
                        class="df aic"
                        style="
                          flex-wrap: wrap;
                          overflow: hidden;
                          max-height: 40px;
                          font-size: 14px;
                        "
                      >
                        {{ v.name }}
                      </div>
                    </div>
                  </template>
                  <template v-if="item.form && item.form.videos">
                    <div
                      v-for="(v, i) in item.form.videos"
                      :key="'video' + i"
                      style="width: 100px; margin: 0 5px"
                    >
                      <div
                        style="
                          width: 80px;
                          height: 80px;
                          position: relative;
                          margin: 10px;
                        "
                        class="mask-container"
                      >
                        <div class="mask-box df aic jcc">
                          <i
                            class="el-icon-zoom-in pointer"
                            style="color: #fff"
                            @click="handlePreview(v.url)"
                          ></i>
                          <div style="width: 20px; height: 20px"></div>
                          <i
                            class="el-icon-delete pointer"
                            style="color: #fff"
                            @click="handleVideoRemove(item, i)"
                          ></i>
                        </div>
                        <img
                          src="@/assets/img/video.png"
                          style="width: 100%; height: 100%; object-fit: cover"
                        />
                        <!-- position: relative; -->
                      </div>

                      <div
                        class="df aic"
                        style="
                          flex-wrap: wrap;
                          overflow: hidden;
                          max-height: 40px;
                          font-size: 14px;
                        "
                      >
                        {{ v.name }}
                      </div>
                    </div>
                  </template>
                </div>

                <div
                  class="df aic"
                  style="justify-content: flex-end; margin-top: 10px"
                >
                  <el-upload
                    class="upload-demo"
                    action="#"
                    :show-file-list="false"
                    :http-request="
                      (params) => {
                        addImg(params, item);
                      }
                    "
                    multiple
                  >
                    <img
                      class="pointer"
                      src="@/assets/img/image.png"
                      style="width: 20px; height: 20px; object-fit: cover"
                    />
                  </el-upload>
                  <el-upload
                    class="upload-demo"
                    action="#"
                    :show-file-list="false"
                    :http-request="
                      (params) => {
                        addVideo(params, item);
                      }
                    "
                    multiple
                  >
                    <img
                      class="pointer"
                      src="@/assets/img/video.png"
                      style="
                        width: 20px;
                        height: 20px;
                        object-fit: cover;
                        margin-left: 20px;
                      "
                    />
                  </el-upload>

                  <el-button
                    @click="createCorrect(item)"
                    size="mini"
                    type="primary"
                    style="margin-left: 20px"
                    >新增纠偏</el-button
                  >
                </div>
              </div>
              <div
                v-for="c in item.correctList"
                :key="c.id"
                style="
                  background-color: #fff;
                  border-radius: 10px;
                  margin-top: 10px;
                "
              >
                <div
                  style="
                    height: 40px;
                    padding: 0px 10px 0 20px;
                    justify-content: flex-end;
                  "
                  class="df aic"
                >
                  <el-popover placement="bottom" width="100px" trigger="hover">
                    <div
                      class="more-btn df aic jcc pointer"
                      style="color: #409eff"
                      @click="c.isEdit = true"
                    >
                      修改
                    </div>
                    <div
                      class="more-btn df aic jcc pointer"
                      style="color: #f56c6c; margin-top: 5px"
                      @click="delCorrect(item, c)"
                    >
                      删除
                    </div>
                    <div class="more-box" slot="reference">
                      <i class="el-icon-more"></i>
                    </div>
                  </el-popover>
                </div>
                <div style="padding: 0px 30px" v-if="!c.isEdit">
                  {{ c.txtInfo }}
                </div>
                <div v-else style="padding: 10px">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="c.txtInfo"
                  ></el-input>
                </div>
                <div
                  v-if="!c.isEdit"
                  class="df aic"
                  style="
                    flex-wrap: wrap;
                    margin-bottom: 10px;
                    padding: 0px 10px;
                  "
                >
                  <template v-if="c.imgInfo">
                    <div
                      v-for="(v, i) in JSON.parse(c.imgInfo)"
                      :key="'img' + i"
                      class="pointer"
                      style="width: 120px; margin: 0 5px"
                    >
                      <div style="width: 100px; height: 100px; margin: 10px">
                        <!-- <img
                          :src="v.url"
                          @click="handlePreview(v.url)"
                          style="width: 100%; height: 100%; object-fit: cover"
                        /> -->
                        <el-image
                          :src="v.url"
                          :preview-src-list="[v.url]"
                          style="width: 100%; height: 100%; object-fit: cover"
                        >
                        </el-image>
                      </div>

                      <!-- <div
                        class="df aic"
                        style="
                          flex-wrap: wrap;
                          overflow: hidden;
                          max-height: 40px;
                          font-size: 14px;
                        "
                      >
                        {{ v.name }}
                      </div> -->
                    </div>
                  </template>
                  <template v-if="c.videoInfo">
                    <div
                      v-for="(v, i) in JSON.parse(c.videoInfo)"
                      :key="'video' + i"
                      class="pointer"
                      style="width: 120px; margin: 0 5px"
                    >
                      <img
                        @click="handlePreview(v.url)"
                        src="@/assets/img/video-play.png"
                        style="
                          width: 100px;
                          height: 100px;
                          object-fit: cover;
                          margin: 10px;
                        "
                      />
                      <!-- <div
                        class="df aic"
                        style="
                          flex-wrap: wrap;
                          overflow: hidden;
                          max-height: 40px;
                          font-size: 14px;
                        "
                      >
                        {{ v.name }}
                      </div> -->
                    </div>
                  </template>
                </div>
                <div v-else style="padding: 10px">
                  <div class="df aic" style="flex-wrap: wrap">
                    <template v-if="c.imgInfo && JSON.parse(c.imgInfo)">
                      <div
                        v-for="(v, i) in JSON.parse(c.imgInfo)"
                        :key="'img' + i"
                        style="width: 100px; margin: 0 5px"
                      >
                        <div
                          style="
                            width: 80px;
                            height: 80px;
                            margin: 10px;
                            position: relative;
                          "
                          class="mask-container"
                        >
                          <div class="mask-box df aic jcc">
                            <i
                              class="el-icon-zoom-in pointer"
                              style="color: #fff"
                              @click="handlePreview(v.url)"
                            ></i>
                            <div style="width: 20px; height: 20px"></div>
                            <i
                              class="el-icon-delete pointer"
                              style="color: #fff"
                              @click="handleEditImgRemove(c, i)"
                            ></i>
                          </div>

                          <!-- <img
                            :src="v.url"
                            style="width: 100%; height: 100%; object-fit: cover"
                          /> -->
                          <el-image
                            :src="v.url"
                            :preview-src-list="[v.url]"
                            style="width: 100%; height: 100%; object-fit: cover"
                          >
                          </el-image>
                        </div>

                        <div
                          class="df aic"
                          style="
                            flex-wrap: wrap;
                            overflow: hidden;
                            max-height: 40px;
                            font-size: 14px;
                          "
                        >
                          {{ v.name }}
                        </div>
                      </div>
                    </template>
                    <template
                      v-if="c.videoInfo && JSON.parse(c.videoInfo).length"
                    >
                      <div
                        v-for="(v, i) in JSON.parse(c.videoInfo)"
                        :key="'video' + i"
                        style="width: 100px; margin: 0 5px"
                      >
                        <div
                          class="mask-container"
                          style="
                            width: 80px;
                            height: 80px;
                            object-fit: cover;
                            margin: 10px;
                            position: relative;
                          "
                        >
                          <div class="mask-box df aic jcc">
                            <i
                              class="el-icon-zoom-in pointer"
                              style="color: #fff"
                              @click="handlePreview(v.url)"
                            ></i>
                            <div style="width: 20px; height: 20px"></div>
                            <i
                              class="el-icon-delete pointer"
                              style="color: #fff"
                              @click="handleEditVideoRemove(c, i)"
                            ></i>
                          </div>
                          <img
                            src="@/assets/img/video.png"
                            style="width: 100%; height: 100%"
                          />
                        </div>

                        <div
                          class="df aic"
                          style="
                            flex-wrap: wrap;
                            overflow: hidden;
                            max-height: 40px;
                            font-size: 14px;
                          "
                        >
                          {{ v.name }}
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="df aic"
                    style="justify-content: flex-end; margin-top: 10px"
                  >
                    <el-upload
                      class="upload-demo"
                      action="#"
                      :show-file-list="false"
                      :http-request="
                        (params) => {
                          editAddImg(params, c);
                        }
                      "
                      multiple
                    >
                      <img
                        class="pointer"
                        src="@/assets/img/image.png"
                        style="width: 20px; height: 20px; object-fit: cover"
                      />
                    </el-upload>
                    <el-upload
                      class="upload-demo"
                      action="#"
                      :show-file-list="false"
                      :http-request="
                        (params) => {
                          editAddVideo(params, c);
                        }
                      "
                      multiple
                    >
                      <img
                        class="pointer"
                        src="@/assets/img/video.png"
                        style="
                          width: 20px;
                          height: 20px;
                          object-fit: cover;
                          margin-left: 20px;
                        "
                      />
                    </el-upload>

                    <el-button
                      @click="editCorrect(item, c)"
                      size="mini"
                      type="success"
                      style="margin-left: 20px"
                      >修改</el-button
                    >
                  </div>
                </div>
                <div class="df aic jcb" style="padding: 5px 20px">
                  <div style="color: #bbb">
                    纠偏人:{{ c.updatedName ? c.updatedName : c.createdName }}
                  </div>
                  <div style="font-size: 14px; color: #bbb">
                    {{
                      c.updatedTime
                        ? c.updatedTime.replace("T", " ")
                        : c.createdTime.replace("T", " ")
                    }}
                  </div>
                </div>
              </div>
              <div
                class="df aic"
                style="justify-content: flex-end; margin-top: 10px"
                v-if="item.correctListTotal"
              >
                <el-pagination
                  background
                  :page-size="5"
                  layout="total,prev, pager, next"
                  :current-page="item.correctQuery.page"
                  @current-change="(page) => handleCorrect(page, item)"
                  :total="item.correctListTotal"
                >
                </el-pagination>
              </div>
              <div
                class="pointer"
                style="width: 100%; text-align: center; color: #409eff"
                @click="item.isCollapse = !item.isCollapse"
              >
                折叠<i
                  class="el-icon-arrow-up"
                  style="margin-left: 5px; color: #409eff"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="t-close" @click="closeTrace">×</div>
        <div class="t-title">工序记录</div>
        <!-- </el-collapse> -->
      </div>
    </div>
  </div>
</template>

<script>
import CcpCharts from "../CcpCharts.vue";
import api from "@/util/extra-api";
import { local } from "@/util/util";
import axios from "@/util/api";

export default {
  name: "CustomStep",
  components: {
    CcpCharts,
  },
  props: {
    stepsData: {
      type: Array,
      default() {
        return [];
      },
    },
    companyId: {
      type: Number,
      default() {
        return 0;
      },
    },
    haccpType: {
      type: Number,
      default() {
        return 0;
      },
    },
    finishedTag: {
      type: String,
    },
    isCcp: {
      type: Boolean,
    },
  },
  data() {
    return {
      cellWidth: 120,
      cellHeight: 150,
      cellConunt: 9,
      pointWidth: 36,
      lineWidth: 4,
      clientWidth: 1200,
      isAdjust: false,
      showInfo: false,
      traceList: [],
    };
  },
  mounted() {
    // console.dir(this.$refs.container);
    this.clientWidth = this.$refs.container.clientWidth;
    if (this.clientWidth / this.cellWidth > this.stepsData.length) {
      this.isAdjust = true;
      this.cellWidth = this.clientWidth / (this.stepsData.length + 2);
    } else {
      this.isAdjust = false;
    }
  },
  methods: {
    closeTrace() {
      this.showInfo = false;
    },
    handleCorrect(page, data) {
      this.$set(data.correctQuery, "page", page);
      // item.correctQuery.page = page;
      this.getCorrectList(data.correctQuery, data);
    },
    editCorrect(item, data) {
      let parmas = {
        id: data.id,
        companyId: this.companyId,
        ccpId: item.id,
      };
      if (data.txtInfo) {
        parmas.txtInfo = data.txtInfo;
      }
      if (data.imgInfo) {
        parmas.imgInfo = data.imgInfo;
      }
      if (data.videoInfo) {
        parmas.videoInfo = data.videoInfo;
      }
      if (!data.txtInfo && !data.imgInfo && !data.videoInfo) {
        this.$message.error("请正确输入/上传纠偏信息");
        return;
      }
      api.post("/v1/pc/haccpScreen/updCorrect", parmas).then((res) => {
        if (res.code === 200) {
          this.getCorrectList(item.correctQuery, item);
        }
      });
    },
    editAddVideo(params, data) {
      const file = params.file,
        fileType = file.type,
        isVidoe = fileType.includes("video");
      // console.log(file, isVidoe);
      if (!isVidoe) {
        this.$message.error("只能上传视频格式!");
        return false;
      }
      const fileFormData = new FormData();
      fileFormData.append("file", file);
      fileFormData.append("company_id", this.companyId);
      fileFormData.append(
        "user_id",
        local.get("user") && local.get("user").user_id
      );
      axios.uploadFile("/pc/file/common", fileFormData).then((resp) => {
        if (resp.code != 200) {
          this.$message.error("视频上传失败，请重新上传");
        } else {
          let videos = null;
          if (data.videoInfo && JSON.parse(data.videoInfo).length) {
            videos = JSON.parse(data.videoInfo);
          } else {
            videos = [];
          }
          videos.push({
            name: resp.name,
            url: resp.url,
          });
          this.$set(data, "videoInfo", JSON.stringify(videos));
        }
      });
    },
    handleEditImgRemove(data, i) {
      console.log(data, i, "图片");
      this.$set(
        data,
        "imgInfo",
        JSON.stringify(
          JSON.parse(data.imgInfo).filter((item, index) => index !== i)
        )
      );
    },
    delCorrect(item, data) {
      api.post("/v1/pc/haccpScreen/delCorrect", { id: data.id }).then((res) => {
        if (res.code === 200) {
          if (item.correctQuery.page !== 1 && item.correctList.length === 1) {
            item.correctQuery.page--;
            this.getCorrectList(item.correctQuery, item);
          } else {
            this.getCorrectList(item.correctQuery, item);
          }
        }
      });
    },
    createCorrect(data) {
      // console.log(data);
      if (
        data.form.text ||
        (data.form.imgs && data.form.imgs.length) ||
        (data.form.videos && data.form.videos.length)
      ) {
        let parmas = {
          ccpId: data.id,
          companyId: this.companyId,
        };
        if (data.form.text) {
          parmas.txtInfo = data.form.text;
        }
        if (data.form.imgs && data.form.imgs.length) {
          parmas.imgInfo = JSON.stringify(data.form.imgs);
        }
        if (data.form.videos && data.form.videos.length) {
          parmas.videoInfo = JSON.stringify(data.form.videos);
        }
        api.post("/v1/pc/haccpScreen/correct", parmas).then((res) => {
          if (res.code === 200) {
            this.$set(data, "form", {
              text: "",
              imgs: [],
              videos: [],
            });
            this.getCorrectList(data.correctQuery, data);
          }
        });
      } else {
        this.$message.error("请正确输入/上传纠偏信息");
      }
    },
    addVideo(params, data) {
      const file = params.file,
        fileType = file.type,
        isVidoe = fileType.includes("video");
      // console.log(file, isVidoe);
      if (!isVidoe) {
        this.$message.error("只能上传视频格式!");
        return false;
      }
      const fileFormData = new FormData();
      fileFormData.append("file", file);
      fileFormData.append("company_id", this.companyId);
      fileFormData.append(
        "user_id",
        local.get("user") && local.get("user").user_id
      );
      axios.uploadFile("/pc/file/common", fileFormData).then((resp) => {
        if (resp.code != 200) {
          this.$message.error("视频上传失败，请重新上传");
        } else {
          // console.log(resp.data);
          let videos = null;
          if (data.form && data.form.videos) {
            videos = data.form.videos;
          } else {
            videos = [];
          }
          videos.push({
            name: resp.name,
            url: resp.url,
          });
          if (!data.form) {
            this.$set(data, "form", { videos });
          } else {
            // console.log(data.form);
            this.$set(data.form, "videos", videos);
          }
          // console.log(data);
        }
      });
    },
    handleVideoRemove(data, i) {
      // console.log(data, i, "视频");
      this.$set(
        data.form,
        "videos",
        data.form.videos.filter((item, index) => index !== i)
      );
    },
    handleEditVideoRemove(data, i) {
      // console.log(data, i, "视频");
      this.$set(
        data,
        "videoInfo",
        JSON.stringify(
          JSON.parse(data.videoInfo).filter((item, index) => index !== i)
        )
      );
    },
    addImg(params, data) {
      const file = params.file,
        fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isLt10M = file.size / 1024 / 1024 < 10;
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error("只能上传图片格式png、jpg、gif!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("只能上传图片大小小于10M");
        return false;
      }
      const fileFormData = new FormData();
      fileFormData.append("file", file);
      fileFormData.append("company_id", this.companyId);
      fileFormData.append(
        "user_id",
        local.get("user") && local.get("user").user_id
      );
      axios.uploadFile("/pc/file/common", fileFormData).then((resp) => {
        if (resp.code != 200) {
          this.$message.error("图片上传失败，请重新上传");
        } else {
          let imgs = null;
          if (data.form && data.form.imgs) {
            imgs = data.form.imgs;
          } else {
            imgs = [];
          }
          imgs.push({
            name: resp.name,
            url: resp.url,
          });
          if (!data.form) {
            this.$set(data, "form", { imgs });
          } else {
            // console.log(data.form);
            this.$set(data.form, "imgs", imgs);
          }
          // console.log(data);
        }
      });
    },
    editAddImg(params, data) {
      const file = params.file,
        fileType = file.type,
        isImage = fileType.indexOf("image") != -1,
        isLt10M = file.size / 1024 / 1024 < 10;
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error("只能上传图片格式png、jpg、gif!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("只能上传图片大小小于10M");
        return false;
      }
      const fileFormData = new FormData();
      fileFormData.append("file", file);
      fileFormData.append("company_id", this.companyId);
      fileFormData.append(
        "user_id",
        local.get("user") && local.get("user").user_id
      );
      axios.uploadFile("/pc/file/common", fileFormData).then((resp) => {
        if (resp.code != 200) {
          this.$message.error("图片上传失败，请重新上传");
        } else {
          let imgs = null;
          if (data.imgInfo && JSON.parse(data.imgInfo).length) {
            imgs = JSON.parse(data.imgInfo);
          } else {
            imgs = [];
          }
          imgs.push({
            name: resp.name,
            url: resp.url,
          });
          this.$set(data, "imgInfo", JSON.stringify(imgs));
          // console.log(data);
        }
      });
    },
    handleImgRemove(data, i) {
      // console.log(data, i, "图片");
      this.$set(
        data.form,
        "imgs",
        data.form.imgs.filter((item, index) => index !== i)
      );
    },
    handlePreview(url) {
      window.open(url);
    },
    getCorrectList(query, data) {
      api.get("/v1/pc/haccpScreen/correctList", query).then((res) => {
        if (res.code === 200) {
          if (!data.isCollapse) {
            data.isCollapse = true;
            this.$set(
              data,
              "correctList",
              res.data.map((v) => {
                return {
                  ...v,
                  isEdit: false,
                };
              })
            );
            this.$set(data, "correctListTotal", res.total);
          } else {
            this.$set(data, "correctList", res.data);
            this.$set(data, "correctListTotal", res.total);
          }
        }
      });
    },
    openCollapse(item) {
      let query = {
        ccpId: item.id,
        companyId: this.companyId,
        page: 1,
        limit: 5,
      };
      this.$set(item, "correctQuery", query);
      this.getCorrectList(query, item);
    },
    pageChange(sensorItem) {
      if (sensorItem.historyData.length < sensorItem.total) {
        sensorItem.query.page++;
        if (sensorItem.query.type) {
          api
            .get("/v1/wx/monitor/localSensorData", sensorItem.query)
            .then((res) => {
              if (res.code === 200) {
                // console.log(res.data.data);
                this.$set(
                  sensorItem,
                  "historyData",
                  res.data.data[0].historyData
                    .reverse()
                    .concat(sensorItem.historyData)
                );
                sensorItem.total = res.data.total;
                this.$set(
                  sensorItem,
                  "hasMore",
                  sensorItem.historyData.length !== sensorItem.total
                );
              }
            });
        } else {
          api.get("/v1/wx/monitor/sensorData", sensorItem.query).then((res) => {
            if (res.code === 200) {
              this.$set(
                sensorItem,
                "historyData",
                res.data.historyData.concat(sensorItem.historyData)
              );
              this.$set(
                sensorItem,
                "hasMore",
                sensorItem.historyData.length !== sensorItem.total
              );

              sensorItem.total = res.data.total;
            }
          });
        }
      }
    },
    toTrace(d) {
      if ((d.isCcp && d.active) || (d.active && !this.isCcp)) {
        let data;
        if (this.haccpType === 1) {
          data = {
            cateringHaccpId: d.recordId,
            companyId: this.companyId,
            haccpTemplateId: d.id,
          };
        } else {
          data = {
            productionRecordId: d.recordId,
            companyId: this.companyId,
            haccpTemplateId: d.id,
          };
        }
        if (this.finishedTag || this.finishedTag === "0") {
          data.finishedTag = this.finishedTag;
        }
        api.get("/v1/pc/haccpScreen/submitCcpData", data).then((res) => {
          if (res.code === 200) {
            this.traceList = res.data;
            this.traceList.forEach((v) => {
              this.$set(v, "isCollapse", false);
              this.$set(v, "form", { text: "" });
              if (v.type === 8 || v.type === 16) {

                this.$set(v, "loading", true);
                this.$set(v, "initFlag", false);

                v.query = {
                  page: 1,
                  limit: 15,
                  id: v.id,
                  type: "task_haccp_sensor",
                };
                v.total = 0;
                api
                  .get("/v1/wx/monitor/localSensorData", v.query)
                  .then((res) => {
                    if (res.code === 200) {
                      v.total = res.data.total;
                      v.data = res.data.data[0];
                      this.$set(
                        v,
                        "historyData",
                        res.data.data[0].historyData.reverse()
                      );
                      v.option = null;
                      this.$set(v, "hasMore", v.historyData.length !== v.total);
                      this.$set(v, "initFlag", true);
                      this.$set(v, "loading", false);
                    }
                  });
              } else if (v.type === 7) {
                v.content = JSON.parse(v.content);

                v.content.forEach((senserItem) => {
                  this.$set(senserItem, "loading", true);
                  this.$set(senserItem, "initFlag", false);
                  senserItem.query = {
                    page: 1,
                    limit: 15,
                    id: senserItem.id,
                  };
                  senserItem.total = 0;

                  api
                    .get("/v1/wx/monitor/sensorData", senserItem.query)
                    .then((res) => {
                      if (res.code === 200) {
                        // console.log(res);
                        senserItem.total = res.data.total;
                        senserItem.data = res.data;
                        this.$set(
                          senserItem,
                          "historyData",
                          res.data.historyData
                        );
                        this.$set(
                          senserItem,
                          "hasMore",
                          senserItem.historyData.length !== senserItem.total
                        );

                        this.$set(senserItem, "initFlag", true);
                        this.$set(senserItem, "loading", false);
                      }
                    });
                });
              }
            });
            this.showInfo = true;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.record-bg {
  background-image: url("../../assets/image/cool-background.png");
  overflow: hidden;
  border-radius: 20px;
  background-size: cover;
  z-index: 100;
  /*background-repeat: no-repeat;*/
}
.p50 {
  padding: 50px 20px !important;
  & > div {
    padding: 10px 0;
    border-top: 1px solid #7bbfea;
    display: flex;
    align-items: center;
  }
  &:last-child {
    padding: 0;
    border-bottom: 1px solid #7bbfea;
  }
}

$stark-light-blue: #00fffc;
$stark-med-blue: #00a4a2;
#fade-box {
  animation: form-entry 2s ease-in-out;
  /*background: #111;*/
  /*background: linear-gradient(#004746, #111);*/
  border: 1px solid $stark-med-blue;
  box-shadow: 0 0 15px #00fffd;
  border-radius: 20px;
  /*display: inline-block;*/
  /*height: 220px;*/
  /*margin: 200px auto 0;*/
  /*position: relative;*/
  z-index: 40;
  /*width: 500px;*/
  transition: 1s all;

  &:hover {
    border: 1px solid #00fffd;
    box-shadow: 0 0 25px #00fffd;
    transition: 1s all;
  }
}
@keyframes form-entry {
  0% {
    max-height: 80vh;
    width: 0;
    opacity: 0;
    padding: 0;
  }
  20% {
    max-height: 80vh;
    border: 4px solid $stark-med-blue;
    width: 0;
    opacity: 0;
    padding: 0;
  }

  40% {
    width: 0;
    max-height: 80vh;
    border: 4px solid $stark-med-blue;
    opacity: 1;
    padding: 0;
  }

  100% {
    max-height: 80vh;
    width: 800px;
  }
}
@keyframes input-entry {
  0% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.t-dialog {
  max-height: 70vh !important;
  overflow: scroll !important;
  width: 1200px !important;
}
.jcb {
  justify-content: space-between;
}
.more-box {
  padding: 5px 10px;
  border-radius: 8px;
}
.more-box:hover {
  background-color: #ededed;
}
.more-btn {
  width: 100%;
  padding: 5px 10px;
  // border-radius: 8px;
}
.more-btn:hover {
  background-color: #ededed;
}
.jcc {
  justify-content: center;
}
.mask-box {
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.mask-container:hover .mask-box {
  display: flex;
}
</style>